export default __webpack_public_path__ + "static/mobile-full-in-lin-ad-3d59821c4cb46769f1027d309662c8be.png";